export const Y_AXIS_TICK_PERCENTS = [75, 50, 25, 0];
export const Y_AXIS_LOG_TICK_PERCENTS = [10, 1, 0.1, 0.01];
export const STEP_GAP_PX = 24;
export const STEP_RIGHT_PADDING_PX = 2;
export const BAR_GAP_PX = 6;
export const MINIMUM_BAR_WIDTH_TO_SHOW_COUNT_LABELS = 55;
export const MINIMUM_BAR_WIDTH = 20;
// We set minimum step width equal to a step with 2 of the narrowest bars (MINIMUM_BAR_WIDTH). A step has multiple
// bars when the query is segmented.
export const DEFAULT_MINIMUM_STEP_WIDTH = MINIMUM_BAR_WIDTH * 2 + BAR_GAP_PX + STEP_GAP_PX + STEP_RIGHT_PADDING_PX;
export const MINIMUM_CSS_BAR_HEIGHT_PERCENT = 3;
